import { createContext, useContext } from 'react';

export const ScrollContext = createContext(null);

export function useScrollRoot() {
  return useContext(ScrollContext);
}
